


















import IRecordedApiModel from '@/model/api/recorded/IRecordedApiModel';
import IVideoApiModel from '@/model/api/video/IVideoApiModel';
import container from '@/model/ModelContainer';
import ISnackbarState from '@/model/state/snackbar/ISnackbarState';
import { ISettingStorageModel } from '@/model/storage/setting/ISettingStorageModel';
import Util from '@/util/Util';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as apid from '../../../../api';

interface VideoFileInfo {
    id: apid.VideoFileId;
    name: string;
    isDelete: boolean;
}

@Component({})
export default class RecordedDeleteDialog extends Vue {
    @Prop({ required: true })
    public recordedItem!: apid.RecordedItem;

    @Prop({ required: true })
    public isOpen!: boolean;

    @Prop({ required: false })
    public isDelaySnackbarViewNum: number | undefined;

    public isRemove: boolean = false;
    public videoFiles: VideoFileInfo[] = [];

    private recordedApiModel = container.get<IRecordedApiModel>('IRecordedApiModel');
    private videApiModel = container.get<IVideoApiModel>('IVideoApiModel');
    private snackbarState = container.get<ISnackbarState>('ISnackbarState');
    private setting: ISettingStorageModel = container.get<ISettingStorageModel>('ISettingStorageModel');

    /**
     * Prop で受け取った isOpen を直接は書き換えられないので
     * getter, setter を用意する
     */
    get dialogModel(): boolean {
        return this.isOpen;
    }
    set dialogModel(value: boolean) {
        this.$emit('update:isOpen', value);
    }

    private init(): void {
        if (typeof this.recordedItem.videoFiles === 'undefined') {
            return;
        }

        const isDelete = this.setting.getSavedValue().deleteRecordedDefaultValue;
        this.videoFiles = this.recordedItem.videoFiles.map(v => {
            return {
                id: v.id,
                name: `${v.name} (${Util.getFileSizeStr(v.size)})`,
                isDelete: isDelete,
            };
        });
    }

    @Watch('isOpen', { immediate: true })
    public onChangeState(newState: boolean, oldState: boolean): void {
        if (newState === true && !!oldState === false) {
            this.init();
        } else if (newState === false && oldState === true) {
            // close
            this.$nextTick(async () => {
                await Util.sleep(100);
                // dialog close アニメーションが終わったら要素を削除する
                this.isRemove = true;
                this.$nextTick(() => {
                    this.isRemove = false;
                });
            });
        }
    }

    /**
     * 録画削除
     */
    public async deleteRecorded(): Promise<void> {
        this.dialogModel = false;

        // 削除対象が0件の場合は早期リターンをする
        let isNoDelete = false;
        isNoDelete = this.videoFiles.every(v => v.isDelete === false);
        if (isNoDelete) {
            return;
        }

        try {
            const needsPageback = await this.delete();
            this.$nextTick(async () => {
                if (typeof this.isDelaySnackbarViewNum !== 'undefined') {
                    await Util.sleep(this.isDelaySnackbarViewNum);
                }
                this.snackbarState.open({
                    color: 'success',
                    text: `${this.recordedItem.name} を削除`,
                });
            });

            this.$emit('deleteSuccessful', needsPageback);
        } catch (err) {
            this.snackbarState.open({
                color: 'error',
                text: `${this.recordedItem.name} を削除に失敗`,
            });
            console.error(err);
        }
    }

    /**
     * video 削除処理
     * @return Promise<boolean> 全件削除の場合は true を返す
     */
    private async delete(): Promise<boolean> {
        let isAllDelete = true;
        for (const v of this.videoFiles) {
            if (v.isDelete === false) {
                isAllDelete = false;
                break;
            }
        }

        // 全件削除
        if (isAllDelete === true) {
            await this.recordedApiModel.delete(this.recordedItem.id);

            return true;
        }

        // 個別削除
        let isError = false;
        for (const v of this.videoFiles) {
            if (v.isDelete === true) {
                await this.videApiModel.delete(v.id).catch(err => {
                    console.error(`delete video failed: ${v.id}`);
                    console.error(err);
                    isError = true;
                });
            }
        }

        if (isError !== false) {
            throw new Error('DeleteVideoFailed');
        }

        return false;
    }
}
